import { useMemo } from 'react';
import { useTheme } from '@material-ui/core/styles';

const isSelectedRow = (selectedRow, rowData) => {
  if (!selectedRow || !rowData) return false;
  const selectedId = selectedRow.tableData?.id;
  const rowId = rowData.tableData?.id;
  return selectedId !== undefined && rowId !== undefined && selectedId === rowId;
};

/**
 * Common table styles that react to the active Material UI theme.
 * @param {object} selectedRow optional selected row (material-table row)
 */
export const useTableTheming = (selectedRow) => {
  const theme = useTheme();

  return useMemo(() => {
    const baseText = { color: theme.palette.text.primary };

    return {
      cellStyle: { padding: '0.4em', ...baseText },
      headerStyle: { padding: '0.4em', backgroundColor: theme.palette.background.paper, ...baseText },
      filterRowStyle: { backgroundColor: theme.palette.background.default, ...baseText },
      rowStyle: rowData => ({
        backgroundColor: isSelectedRow(selectedRow, rowData) ? theme.palette.action.selected : theme.palette.background.paper,
        ...baseText
      })
    };
  }, [selectedRow, theme]);
};
